import { render, staticRenderFns } from "./TradeShowList.vue?vue&type=template&id=8c921bce&scoped=true&"
import script from "./TradeShowList.vue?vue&type=script&lang=js&"
export * from "./TradeShowList.vue?vue&type=script&lang=js&"
import style0 from "./TradeShowList.vue?vue&type=style&index=0&id=8c921bce&lang=scss&scoped=true&"
import style1 from "./TradeShowList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c921bce",
  null
  
)

export default component.exports